import React from 'react';

export function TextArea({
  label,
  formik,
  field,
  type = 'text',
  inputSize = 410,
  labelMinSize = 80,
  labelMaxSize,
  height = 80,
  labelClass = '',
  disabled = false,
  id = '',
  direction = '',
}) {
  return (
    <div className="form-group fv-plugins-icon-container">
      <div className={`d-flex ${direction}`}>
        <label
          style={{ minWidth: labelMinSize, maxWidth: labelMaxSize }}
          className={labelClass}
        >
          {label}
        </label>
        <textarea
          autoComplete="on"
          id={id}
          disabled={disabled}
          type={type}
          style={{ width: inputSize, height }}
          className={`form-control form-control-solid py-3 px-4`}
          {...formik.getFieldProps(field)}
        />
      </div>
      {formik.touched[field] && formik.errors[field] ? (
        <div className="d-flex">
          <label style={{ minWidth: labelMinSize, maxWidth: labelMaxSize }}>
            {' '}
          </label>
          <div className="fv-plugins-message-container">
            <div className="fv-help-block">{formik.errors[field]}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
